import { createDialogProvider } from "src/components/Dialog";
import { BulkDuplicateDialogContext } from "./context";
import { BulkDuplicateDialog } from "./BulkDuplicateDialog";

export const { DialogProvider: BulkDuplicateDialogProvider } =
  createDialogProvider(
    BulkDuplicateDialogContext,
    BulkDuplicateDialog,
    "BulkDuplicateDialog"
  );
